import React from 'react';
import { Mail, Phone, ExternalLink } from 'lucide-react';

const Footer = ({ t }) => {
  return (
    <footer className="bg-gradient-to-b from-black to-gray-950 text-white py-16 border-t border-gold/20 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 luxury-pattern opacity-30" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold heading-luxury gold-shimmer">Miguel Ângelo</h3>
            <div className="flex items-center gap-3">
              <img 
                src="https://predimed.pt/img/logo_predimed_branco.png" 
                alt="Predimed"
                className="h-10 object-contain opacity-80 hover:opacity-100 transition-opacity"
              />
            </div>
          </div>

          <div className="space-y-6">
            <h4 className="text-lg font-bold text-gold uppercase tracking-wider">{t.footer.contact}</h4>
            <div className="space-y-4">
              <a 
                href="tel:+351934608020" 
                className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors group"
              >
                <div className="w-10 h-10 bg-gold/10 rounded-lg flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                  <Phone className="h-5 w-5" />
                </div>
                <span>+351 934 608 020</span>
              </a>
              <a 
                href="mailto:miguelangelo@predimed.pt" 
                className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors group"
              >
                <div className="w-10 h-10 bg-gold/10 rounded-lg flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                  <Mail className="h-5 w-5" />
                </div>
                <span className="break-all">miguelangelo@predimed.pt</span>
              </a>
            </div>
          </div>

          <div className="space-y-6">
            <h4 className="text-lg font-bold text-gold uppercase tracking-wider">{t.footer.properties}</h4>
            <a 
              href="https://predimed.pt" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-gray-400 hover:text-gold transition-colors group"
            >
              <span>{t.footer.viewAllPredimed}</span>
              <ExternalLink className="h-4 w-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
            <p className="text-sm text-gray-500">
              {t.footer.accessInfo}
            </p>
          </div>
        </div>

        <div className="border-t border-gold/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Miguel Ângelo. {t.footer.rights}.
            </p>
            <p className="text-gray-600 text-xs">
              {t.footer.designed}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;